import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/country",
    name: "country",
    component: dashboard,
    redirect: {
      name: "baseDataCountry"
    },
    children: [
      {
        path: "baseDataCountry",
        name: "baseDataCountry",
        meta: { title: "国家地区管理" },
        component: () =>
          import("@/views/country/baseDataCountry/countryCode.vue"),
        children: [
          {
            path: "editCountryInfo/:baseDataCountryId",
            name: "editCountryInfo",
            meta: { title: "编辑国家地区" },
            component: () =>
              import("@/views/country/baseDataCountry/countryManage.vue")
          }
        ]
      },
      {
        path: "brandCategory",
        name: "brandCategory",
        meta: { title: "品牌品类管理" },
        component: () => import("@/views/country/brandCategory/index.vue"),
        children: [
          {
            path: "brandManage",
            name: "brandManage",
            meta: { title: "品牌品类信息维护" },
            component: () =>
              import("@/views/country/brandCategory/brandManage.vue")
          }
        ]
      }
    ]
  }
];
